export default {
  title: 'Aloita',
  description: 'Nykyisen sivun lataamiseksi sinun täytyy suorittaa Aloitus-opas loppuun',
  button: 'Aloita',
};
